export interface WorkItem {
  id: string;
  title: string;
  titleEn: string;
  type: '电影' | '电视剧' | '纪录片';
  year: number;
  cover: string;
  director: string;
  cast: string;
  duration: string;
  region: string;
  rating: number;
  tags: string[];
  synopsis: string;
}

export const works: WorkItem[] = [
  {
    id: 'w001',
    title: '夜色微光',
    titleEn: 'Glimmer of Night',
    type: '电影',
    year: 2024,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20portrait%20of%20an%20elegant%20woman%20in%20a%20dimly%20lit%20city%20alley%2C%20moody%20teal%20and%20deep%20red%20tones%2C%20soft%20film%20grain%2C%20editorial%20minimal%20background%2C%20high%20detail&width=600&height=900&seq=ework-01&orientation=portrait',
    director: '佐藤健吾',
    cast: '深田咏美、中岛悠、林原惠',
    duration: '118 分钟',
    region: '日本',
    rating: 8.6,
    tags: ['剧情', '都市', '悬疑'],
    synopsis:
      '《夜色微光》讲述了一位在城市夜班中独自生活的女性，在偶然拾获一封未寄出的信件后，逐渐被卷入一段被时间掩埋的往事。影片以克制而细腻的镜头语言，描摹都市孤独者在霓虹与阴影之间的挣扎与温柔。深田咏美在片中以内敛的表演呈现了角色从疏离到释然的完整弧光，被评论界认为是她近年来最具层次的一次银幕尝试。',
  },
  {
    id: 'w002',
    title: '东京流年',
    titleEn: 'Tokyo Years',
    type: '电视剧',
    year: 2023,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20an%20elegant%20woman%20standing%20by%20a%20rainy%20window%20in%20Tokyo%2C%20muted%20grey%20tones%20with%20deep%20burgundy%20accents%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20style%2C%20high%20detail&width=600&height=900&seq=ework-02&orientation=portrait',
    director: '高桥美咲',
    cast: '深田咏美、森川凉、大野拓真',
    duration: '全 10 集',
    region: '日本',
    rating: 8.2,
    tags: ['都市', '情感', '成长'],
    synopsis:
      '《东京流年》以四季为章节，记录四位年轻人在东京重逢与告别的一年。深田咏美饰演的女主角是一位从地方来到大都市追梦的插画师，在理想与现实的夹缝中重新认识自己。剧集用大量留白与生活细节还原都市青年的真实处境，节奏舒缓却余韵悠长。',
  },
  {
    id: 'w003',
    title: '静默之声',
    titleEn: 'The Silent Voice',
    type: '电影',
    year: 2022,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20minimal%20film%20poster%20of%20an%20elegant%20woman%20in%20profile%20against%20a%20soft%20grey%20concrete%20wall%2C%20deep%20red%20ribbon%20detail%2C%20moody%20editorial%20photography%2C%20grainy%20film%20texture%2C%20high%20detail&width=600&height=900&seq=ework-03&orientation=portrait',
    director: '小林律',
    cast: '深田咏美、藤井树、安藤千夏',
    duration: '104 分钟',
    region: '日本',
    rating: 8.9,
    tags: ['文艺', '剧情', '音乐'],
    synopsis:
      '一位曾经的天才钢琴少女在一次意外后失去了登台的勇气，多年以后，她在一家旧书店里重新听见了改变她一生的那段旋律。影片以声音作为叙事线索，探讨创伤、和解与重新出发的可能，深田咏美的表演安静却极具张力。',
  },
  {
    id: 'w004',
    title: '银幕之后',
    titleEn: 'Behind the Screen',
    type: '纪录片',
    year: 2024,
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20poster%20of%20a%20backstage%20film%20studio%20with%20warm%20spotlight%2C%20muted%20grey%20and%20deep%20red%20palette%2C%20cinematic%20editorial%20photography%2C%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ework-04&orientation=portrait',
    director: '渡边淳一郎',
    cast: '深田咏美 及 制作团队',
    duration: '76 分钟',
    region: '日本',
    rating: 8.0,
    tags: ['纪录', '幕后', '行业'],
    synopsis:
      '《银幕之后》走进拍摄现场的后台，用镜头记录一部电影从筹备、拍摄到杀青的完整过程。深田咏美作为主要讲述者之一，分享了她对表演、角色与职业的理解。纪录片不回避行业的辛苦与不确定，也因此格外真实动人。',
  },
  {
    id: 'w005',
    title: '雨停之前',
    titleEn: 'Before the Rain Stops',
    type: '电影',
    year: 2023,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20romance%20film%20poster%20of%20an%20elegant%20woman%20holding%20a%20transparent%20umbrella%20in%20the%20rain%2C%20soft%20grey%20backdrop%20with%20deep%20red%20accents%2C%20moody%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=ework-05&orientation=portrait',
    director: '中村圭',
    cast: '深田咏美、佐伯悠人、宫本葵',
    duration: '97 分钟',
    region: '日本',
    rating: 8.3,
    tags: ['爱情', '剧情', '雨季'],
    synopsis:
      '一场持续了整整一周的梅雨，让两个本不该相遇的人在同一把伞下短暂相识。《雨停之前》用细腻的日常对话编织出一段克制而温柔的情感，追问着「喜欢一个人，是否一定要有结局」。',
  },
  {
    id: 'w006',
    title: '花火之约',
    titleEn: 'Promise of Fireworks',
    type: '电视剧',
    year: 2022,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20elegant%20woman%20in%20a%20light%20summer%20dress%20under%20fireworks%20in%20a%20night%20sky%2C%20muted%20grey%20and%20warm%20red%20tones%2C%20editorial%20minimal%20style%2C%20high%20detail&width=600&height=900&seq=ework-06&orientation=portrait',
    director: '石原有希',
    cast: '深田咏美、木村翔、冈田莉子',
    duration: '全 8 集',
    region: '日本',
    rating: 7.9,
    tags: ['青春', '夏日', '爱情'],
    synopsis:
      '每年夏天的花火大会，是小镇居民心照不宣的约定。多年以后，几位童年好友为了兑现那个被遗忘的承诺陆续回到故乡。《花火之约》是一部关于时间与记忆的群像剧，温暖而略带惆怅。',
  },
  {
    id: 'w007',
    title: '寒灯独影',
    titleEn: 'Cold Lantern',
    type: '电影',
    year: 2021,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20period%20film%20poster%20of%20an%20elegant%20woman%20in%20a%20dim%20room%20lit%20by%20a%20single%20lantern%2C%20deep%20red%20and%20charcoal%20tones%2C%20moody%20editorial%20photography%2C%20grainy%20texture%2C%20high%20detail&width=600&height=900&seq=ework-07&orientation=portrait',
    director: '黑泽清志',
    cast: '深田咏美、绪方一辉、高梨纱',
    duration: '126 分钟',
    region: '日本',
    rating: 8.7,
    tags: ['时代', '剧情', '悬疑'],
    synopsis:
      '故事发生在昭和末年的山中小镇，一位独自经营旧照相馆的女子，因一张被送错的底片而走进了镇上尘封多年的秘密。《寒灯独影》以冷峻的影像风格和层层递进的悬念，呈现了一个关于真相与宽恕的故事。',
  },
  {
    id: 'w008',
    title: '追光的人',
    titleEn: 'Chasing the Light',
    type: '纪录片',
    year: 2023,
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20poster%20of%20a%20lone%20silhouette%20walking%20toward%20warm%20light%20in%20a%20grey%20foggy%20landscape%2C%20muted%20editorial%20photography%2C%20deep%20red%20highlight%2C%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ework-08&orientation=portrait',
    director: '平田和也',
    cast: '深田咏美 及 纪录片团队',
    duration: '88 分钟',
    region: '日本',
    rating: 8.1,
    tags: ['纪录', '人物', '励志'],
    synopsis:
      '镜头跟随深田咏美走过她演艺生涯中几个重要阶段，记录一位表演者如何在聚光灯之外持续打磨自己。纪录片没有刻意煽情，而是把镜头交给时间，让努力本身说话。',
  },
  {
    id: 'w009',
    title: '城中之夏',
    titleEn: 'Summer in the City',
    type: '电视剧',
    year: 2024,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20elegant%20woman%20on%20a%20city%20rooftop%20at%20golden%20hour%2C%20muted%20grey%20warm%20tones%20with%20deep%20red%20accent%2C%20editorial%20minimal%20style%2C%20high%20detail&width=600&height=900&seq=ework-09&orientation=portrait',
    director: '田野恵',
    cast: '深田咏美、加藤凌、白石奈绪',
    duration: '全 12 集',
    region: '日本',
    rating: 8.4,
    tags: ['都市', '职场', '情感'],
    synopsis:
      '在一家濒临解散的小型设计工作室里，一群年轻人决定用一个夏天赌上全部去完成最后一个项目。《城中之夏》既有职场的真实压力，也有伙伴之间相互支撑的温度。',
  },
  {
    id: 'w010',
    title: '无声告白',
    titleEn: 'A Quiet Confession',
    type: '电影',
    year: 2020,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20intimate%20film%20poster%20of%20an%20elegant%20woman%20in%20soft%20window%20light%2C%20muted%20grey%20background%20with%20deep%20red%20detail%2C%20grainy%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=ework-10&orientation=portrait',
    director: '宫崎夏生',
    cast: '深田咏美、樱井和真、长谷川枫',
    duration: '110 分钟',
    region: '日本',
    rating: 8.5,
    tags: ['剧情', '家庭', '治愈'],
    synopsis:
      '一位在异乡生活多年的女儿回到老家照顾生病的母亲，在两代人沉默的相对中，那些从未说出口的爱与歉疚被一点点重新拾起。《无声告白》是一场关于和解的安静旅程。',
  },
  {
    id: 'w011',
    title: '浮世绘卷',
    titleEn: 'The Floating World',
    type: '电视剧',
    year: 2021,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20poster%20of%20an%20elegant%20woman%20in%20traditional%20elegant%20clothing%2C%20muted%20grey%20and%20deep%20crimson%20palette%2C%20moody%20editorial%20photography%2C%20grainy%20texture%2C%20high%20detail&width=600&height=900&seq=ework-11&orientation=portrait',
    director: '柳原诚',
    cast: '深田咏美、本间佑、篠原千鹤',
    duration: '全 9 集',
    region: '日本',
    rating: 8.0,
    tags: ['时代', '剧情', '群像'],
    synopsis:
      '以一座老城为舞台，讲述几代人在时代变迁中的聚散离合。深田咏美在剧中跨越多个年龄段，诠释了一位女性一生的坚韧与柔软，是全剧情感的核心支点。',
  },
  {
    id: 'w012',
    title: '北纬三十五度',
    titleEn: 'Latitude 35',
    type: '纪录片',
    year: 2022,
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20poster%20of%20a%20wide%20grey%20coastal%20landscape%20at%20dusk%20with%20a%20lone%20figure%2C%20muted%20editorial%20photography%2C%20deep%20red%20horizon%20accent%2C%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ework-12&orientation=portrait',
    director: '村上遥',
    cast: '深田咏美 及 摄制组',
    duration: '82 分钟',
    region: '日本',
    rating: 7.8,
    tags: ['纪录', '旅行', '人文'],
    synopsis:
      '一条沿着北纬三十五度线延伸的公路，串起了沿途小镇、海岸与人群的故事。深田咏美以旅人的视角走进普通人的生活，记录下平凡日子里安静而动人的片段。',
  },
];